import worldLogo from '../../../assets/images/icons/world-logo.svg'
import { Button, MenuItem } from '@mui/material'
import Menu from '@mui/material/Menu'
import { FC, useCallback, useState } from 'react'
import './country-selection.scss'
import { countrySelectionOptions } from '../../../utils/constants'

interface CountrySelectionProps {
    className?: string
}

const CountrySelection: FC<CountrySelectionProps> = ({ className }) => {
    const [country, setCountry] = useState<null | HTMLElement>(null)
    const [openDropDwon, setOpenDropDown] = useState(false)

    const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setCountry(event.currentTarget)
        setOpenDropDown(true)
    }, [])

    const handleClose = useCallback(() => {
        setCountry(null)
        setOpenDropDown(false)
    }, [])

    return (
        <div className={`country-selection ${className}`}>
            <Button
                aria-haspopup="true"
                className="country-btn"
                onClick={handleClick}
                disableRipple
            >
                <img
                    className="location-logo"
                    src={worldLogo}
                    alt="Location Logo"
                />
                <p>US & CANADA</p>
            </Button>
            <Menu
                className="country-selection-wrapper"
                anchorEl={country}
                open={openDropDwon}
                onClose={handleClose}
            >
                {countrySelectionOptions.map((option) => (
                    <a
                        href={option.value}
                        target="_blank"
                        rel="noreferrer"
                        key={`country-${option.key}`}
                    >
                        <MenuItem
                            className="country-selection-item"
                            onClick={handleClose}
                        >
                            <span className="menu-flag">
                                <img src={option.flag} alt="" />
                            </span>
                            <span className="country-name">{option.key}</span>
                        </MenuItem>
                    </a>
                ))}
            </Menu>
        </div>
    )
}

export default CountrySelection
